import type { UIEventHandler } from 'react';
import { useCallback, useState } from 'react';

/**
 * @constant {number}
 * Some scroll and element measurements are rounded by the browser, this covers any discrepancy
 */
const errorMargin = 1;

const useHorizontalScrollEdge = () => {
  const [rightEdgeReached, setRightEdgeReached] = useState(false);
  const [leftEdgeReached, setLeftEdgeReached] = useState(true);

  const handleScroll = useCallback<UIEventHandler<HTMLElement>>((e) => {
    const container = e.currentTarget;
    const { scrollLeft, scrollWidth, clientWidth } = container;
    setRightEdgeReached(scrollLeft + clientWidth >= scrollWidth - errorMargin);
    setLeftEdgeReached(scrollLeft <= 0);
  }, []);

  return {
    handleScroll,
    rightEdgeReached,
    leftEdgeReached
  };
};

export default useHorizontalScrollEdge;
